import PricingPageHelper from "../../Components/Pricing/Index";

const PricingPagePage = () => {
  return <PricingPageHelper />;
};

export default PricingPagePage;
